export class AppSettings {
  public static ShowICPNumber = '';
  public static GA_TRACKING_ID = 'G-R31VKL0XHB';
  public static BUGSNAG_ID = '63123eb41a51c283e4376beb4bf97cd1';
  public static URL_Masters = '';
  public static URL_Users = '';
  public static URL_Settings = '';
  public static URL_Session;
  public static URL_Central;
  public static URL_KMT = '';
  public static URL_KMTMasters = '';
  public static URL_PMSService = '';
  public static URL_LOCAL_MASTER = '';
  public static URL_KMTMastersV2 = '';
  public static URL_WorkOrders = '';
  public static URL_PlatformConfig = '';
  public static URL_Checklist = '';
  public static URL_Attachments = '';
  public static URL_AssetCategory = '';
  public static URL_PM = '';
  public static URL_Asset = '';
  public static URL_MNT_BulkAction = '';
  public static URL_MNT_Gateway = '';
  public static URL_KMTNotification = '';
  public static URL_KMTReports = '';
  public static URL_ComplainService;
  public static URL_KMTConfig;
  public static URL_KMTImport;
  public static URL_Analytics;
  public static URL_Inventory;
  public static SessionID;
  public static EnableUnifocusSSO = false;
  public static Domain: string = '';
  public static IsRunningInSingularity = false;
}

export class AppFeatures {
  public static Debug = false;
  public static InventoryEnabled = true;
  public static TenantId = 1;
  public static supplierTanentId = 123;
  public static ChecklistRadio = true;
  public static SetLanguage = false;
  public static KMTPreArrivalDaysLimit = 0;
  public static AutoAssignmentPollInterval = 300000; // 5 minutes
}
